module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_3.7fa6cca5.webp";